import { HttpErrorResponse } from '@angular/common/http';

export interface ApiErrorViewModel {
  status: number;
  code: string;
  message: string;
  fieldErrors: Record<string, string>;
  traceId?: string;
}

export function toApiErrorViewModel(error: HttpErrorResponse): ApiErrorViewModel {
  const body = (error.error ?? {}) as Record<string, unknown>;
  const status = error.status || 0;
  const code = String(body['code'] ?? fallbackCode(status));
  const fieldErrors = isRecord(body['fieldErrors']) ? Object.fromEntries(Object.entries(body['fieldErrors']).map(([key, value]) => [key, String(value)])) : {};
  return { status, code, message: String(body['message'] ?? fallbackMessage(status)), fieldErrors, traceId: body['traceId'] == null ? undefined : String(body['traceId']) };
}

function fallbackCode(status: number): string { return ({ 400: 'BAD_REQUEST', 401: 'UNAUTHENTICATED', 403: 'FORBIDDEN', 404: 'NOT_FOUND', 409: 'CONFLICT', 422: 'BUSINESS_VALIDATION_ERROR', 500: 'INTERNAL_SERVER_ERROR' } as Record<number, string>)[status] ?? 'API_ERROR'; }
function fallbackMessage(status: number): string { return ({ 400: 'Requête invalide.', 401: 'Session invalide.', 403: 'Accès interdit.', 404: 'Ressource introuvable.', 409: 'Conflit de données.', 422: 'Règle métier non respectée.', 500: 'Erreur interne du serveur.' } as Record<number, string>)[status] ?? 'Une erreur API est survenue.'; }
function isRecord(value: unknown): value is Record<string, unknown> { return !!value && typeof value === 'object' && !Array.isArray(value); }
